import React, { useState } from "react";
import { addschd } from '../api/ApiAtd';

const FillSchedule = ({ sesInfo, setsesInfo}) => {
  const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  const [currentDayIndex, setCurrentDayIndex] = useState(0);
  const [schedule, setSchedule] = useState({}); 
   const [showSubSubmitLoad, setSubSubmitLoad] = useState(false);
  

  const handleSubjectToggle = (subjectId) => {
    const day = days[currentDayIndex];
    setSchedule((prev) => ({
      ...prev,
      [day]: {
        ...(prev[day] || {}),
        [subjectId]: !(prev[day]?.[subjectId] || false),
      },
    }));
  };
  const handleNext = () => {
    if (currentDayIndex < days.length - 1) {
      setCurrentDayIndex(currentDayIndex + 1);
    }
  };

  const handlePrevious = () => {
    if (currentDayIndex > 0) {
      setCurrentDayIndex(currentDayIndex - 1);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubSubmitLoad(true)
    const formattedSchedule = Object.keys(schedule).reduce((acc, day) => {
      acc[day] = Object.keys(schedule[day]).filter((subjectId) => schedule[day][subjectId]);
      return acc;
    }, {});
    try {
      const response = await addschd(sesInfo.sesDet._id, formattedSchedule);
      setsesInfo(response.data);
    } catch (error) {
      console.error("Error saving data:", error);
      alert("An error occurred while saving data.");
    }finally{
        setSubSubmitLoad(false)
    }
  };

  return (
    <div className="mt-4 p-5 rounded-lg shadow bg-white">
      <h2 className="text-2xl font-semibold text-center mb-4 text-gray-800">
        Schedule for <span className="text-blue-600">{days[currentDayIndex]}</span>
      </h2>
      {Object.entries(sesInfo.sesData.subjects).map(([id, subjectName]) => (

        <>
          <div
            role="button"
            class={"flex mt-1 w-full items-center rounded-lg p-0 transition-all hover:bg-slate-100 focus:bg-slate-100 active:bg-slate-100 "+((schedule[days[currentDayIndex]]?.[id] || false)? ("bg-slate-200"): (""))}
          >
            <label
              htmlFor={`subject-${id}`}
              class="peer flex w-full cursor-pointer items-center px-3 py-2"
            >
              <div class="inline-flex items-center">
                <label class="flex items-center cursor-pointer relative" htmlFor={`subject-${id}`}>
                  <input type="checkbox"
                  checked={schedule[days[currentDayIndex]]?.[id] || false}
                  onChange={() => handleSubjectToggle(id)}
                    class="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
                    id={`subject-${id}`} />
                  <span class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                    <svg  xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor"
                      stroke="currentColor" stroke-width="1">
                      <path fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"></path>
                    </svg>
                  </span>
                </label>
                <label class="cursor-pointer ml-2 text-slate-600 text-sm" htmlFor={`subject-${id}`}>
                  {subjectName}
                </label>
              </div>
            </label>
          </div>
        </>
      ))}
      <div className="mt-6 flex justify-between">
        {currentDayIndex > 0 && (
          <button
            onClick={handlePrevious}
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 focus:ring-2 focus:ring-gray-400 cursor-pointer"
          >
            Previous
          </button>
        )}
        {currentDayIndex < days.length - 1 ? (
          <button
            onClick={handleNext}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:ring-2 focus:ring-blue-400 cursor-pointer"
          >
            Next
          </button>
        ) : (
          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 focus:ring-2 focus:ring-green-400 cursor-pointer"
          >
            {showSubSubmitLoad ? (<>
              <div className="flex items-center">
                <div class="w-3 h-3 rounded-full animate-spin
border-2 border-solid border-white border-t-transparent mr-2"></div>
                Submitting...</div>
            </>) : (<>
              Submit
            </>)}
          </button>
        )}
      </div>
    </div>
  );
};

export default FillSchedule;
